import Vue from 'vue'
import VueGtag from 'vue-gtag'
import router from '@/router'

const gaID = process.env.VUE_APP_GA4_ID

if (gaID) {
  Vue.use(VueGtag, {
    config: {
      id: gaID,
      params: { anonymize_ip: true }
    },
    enabled: !window.navigator.doNotTrack || window.navigator.doNotTrack === '0'
  }, router)
} else {
  console.warn('Missing environment variable: VUE_APP_GA4_ID')
}
